import { djb2Hash } from './djb2-hash.util';

const HEX_RADIX = 16;
const HEX_WIDTH = 8;
const EMPTY_HASH = '0'.repeat(HEX_WIDTH * 2);
/** A NUL byte reseeds the second pass, so the two halves are not the same function of the input. */
const SECOND_PASS_SEPARATOR = '\x00';

/**
 * Hash content to a 16-character hex string (64 bits).
 *
 * Two djb2 passes with different seeds, concatenated — collision probability drops from roughly
 * 1 in 2^32 to 1 in 2^64. Use this where a false "unchanged" would be expensive; `hashContent` is
 * enough where it would not.
 *
 * Ported from Clarity `apps/web/src/shared/utils/hashUtils.ts`.
 */
export function hashContentToHex(content: string): string {
	if (!content) {
		return EMPTY_HASH;
	}

	const first = djb2Hash(content).toString(HEX_RADIX).padStart(HEX_WIDTH, '0');
	const second = djb2Hash(content + SECOND_PASS_SEPARATOR)
		.toString(HEX_RADIX)
		.padStart(HEX_WIDTH, '0');

	return first + second;
}
